import styled from "styled-components";

const Aside = styled.aside`
  grid-area: aside;
  z-index: 1;
  box-shadow: 5px 0 5px #000000;
  background-color: #393431;
  font-size: 0.8em;

  @media screen and (max-width: 600px) {
    grid-area: aside;
  }
`;

export default Aside;
